export function FormatPrice() {
  return Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  });
}

export function IsChangeModalEnabled() {
  const changeModal = localStorage.getItem("changeModal");
  if (changeModal) return true;
  return false;
}

export function IsQrCodeReaderEnabled() {
  const qrcodeReader = localStorage.getItem("qrcodeReader");
  if (qrcodeReader) return true;
  return false;
}

export function SetChangeModalEnabled(isEnabled) {
  if (isEnabled) {
    localStorage.setItem("changeModal", true);
    return;
  }
  localStorage.removeItem("changeModal");
}

export function SetQrCodeReaderEnabled(isEnabled) {
  if (isEnabled) {
    localStorage.setItem("qrcodeReader", true);
    return;
  }
  localStorage.removeItem("qrcodeReader");
}

export function GetPrinter() {
  const savedPrinter = localStorage.getItem("printer");
  if (savedPrinter) return savedPrinter;

  return "";
}

export function SetPrinter(printerName) {
  localStorage.setItem("printer", printerName);
}
